import axios from '@/api/axios'
// import _ from 'lodash'

const apiUrlEx = '/v1/car'

const list = async (curPage, sk, result) => {
  let finalData = {
    items: {},
    totalPage: 0
  }
  const options = {
    method: 'GET',
    url: apiUrlEx,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      page: curPage,
      sk: sk
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData.items = response.data.data
        finalData.totalPage = response.data.paginate.totalPage
        result(finalData)
      } else {
        result(null)
      }
    })

}

const get = async (seq, result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/' + seq,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  }
  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        result(response.data.data)
      } else {
        result(null)
      }
    })
}

const smallCarList = async (result) => {
  let finalData = []

  const options = {
    method: 'GET',
    url: apiUrlEx + '/small-car-list',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData = response.data.data
        result(finalData)
      } else {
        result(null)
      }
    })
}

const carMonthCount = async (id, sdate, edate, result) => {
  let finalData = []

  const options = {
    method: 'GET',
    url: apiUrlEx + '/car-month-count',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      id: id,
      sdate: sdate,
      edate: edate
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData = response.data.data
        result(finalData)
      } else {
        result(null)
      }
    })
}

const carInfo = async (cseq, result) => {
  let finalData = []
  const options = {
    method: 'GET',
    url: apiUrlEx + '/car-info',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      cseq: cseq
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData = response.data.data
        result(finalData)
      } else {
        result(null)
      }
    })

}

const carInfoEx = async (cseq, result) => {
  let finalData = []
  const options = {
    method: 'GET',
    url: apiUrlEx + '/car-info-ex',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      cseq: cseq
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData = response.data.data
        result(finalData)
      } else {
        result(null)
      }
    })
}

const carInsChange = async (cseq, date, result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/car-ins-change',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      cseq: cseq,
      date: date
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 300) {
        result(response.data.message)
      } else {
        result(null)
      }
    })

}

const lastCarTdist = async (id, result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/last-car-tdist',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      id: id
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        result(response.data.data)
      } else {
        result(null)
      }
    })
}

export default {
  list,
  get,
  carMonthCount,
  smallCarList,
  carInfo,
  carInsChange,
  lastCarTdist
}

export {
  carMonthCount,
  smallCarList,
  carInfo,
  carInfoEx,
  lastCarTdist
}
